<template>
  <div class="flex">
    <router-link
      v-if="canEdit || canView"
      :to="currentRoute + '/' + getEntityId(item) + '/detail'"
    >
      <md-button class="md-just-icon md-success md-simple table-action ">
        <md-tooltip md-direction="top">{{ $t("common.edit") }}</md-tooltip>
        <md-icon v-if="canEdit">edit</md-icon>
        <md-icon v-if="canView && !canEdit">visibility</md-icon>
      </md-button>
    </router-link>
    <md-button
      v-if="canCopy"
      class="md-just-icon md-warning md-simple table-action "
      @click.native="triggerConfirmCopy"
    >
      <md-tooltip md-direction="top"> {{ $t("common.copy") }}</md-tooltip>
      <md-icon>content_copy</md-icon>
    </md-button>

    <md-button
      v-if="item.status === 'On-going' && canConclude"
      @click.native="triggerConfirmConclude"
      class="md-just-icon md-info md-simple table-action "
    >
      <md-tooltip md-direction="top"> {{ $t("common.concluded") }}</md-tooltip>
      <i class="far fa-check-circle"></i>
    </md-button>
    <md-button
      v-if="canDelete"
      class="md-just-icon md-danger md-simple table-action"
      @click.native="triggerConfirmDelete"
    >
      <md-tooltip md-direction="top">{{ $t("common.delete") }}</md-tooltip>
      <md-icon>close</md-icon>
    </md-button>
  </div>
</template>

<script>
import { service_paths } from "@/constants/Services";
import { Term } from "@/constants/Permissions";

export default {
  props: ["item"],
  data() {
    return {
      path: service_paths.terms,
      Term
    };
  },
  computed: {
    currentRoute() {
      return this.$route.path.endsWith("/")
        ? this.$route.path.slice(0, -1)
        : this.$route.path;
    },
    canEdit() {
      return this.$can(Term.actions.edit, Term.subject);
    },
    canView() {
      return this.$can(Term.actions.view, Term.subject);
    },
    canDelete() {
      return this.$can(Term.actions.delete, Term.subject);
    },
    canCopy() {
      return this.$can(Term.actions.copy, Term.subject);
    },
    canConclude() {
      return this.$can(Term.actions.conclude, Term.subject);
    }
  },
  inject: ["confirmCopy", "confirmDelete", "confirmConclude"],
  methods: {
    // copy
    triggerConfirmCopy() {
      this.confirmCopy(this.item);
    },
    triggerConfirmDelete() {
      this.confirmDelete(this.item);
    },
    triggerConfirmConclude() {
      this.confirmConclude(this.item);
    },
    getEntityId(item) {
      return item.id || item._id;
    }
  }
};
</script>
